package de.oevbs.kunde.kundenportal2

interface ProgressStep {
    val id: String
}

enum class GeneralProgressStep(
    override val id: String
) : ProgressStep {
    SUBMIT1("submitData"),
    SUCCESS2("success")
}

enum class PinAuthenticationStep(
    override val id: String
) : ProgressStep {
    CHECKPIN1("submitPin"),
    SELECTMAIL2("selectMail"),
    SUCCESS3("success")
}

enum class RetrieveUserStep(
    override val id: String
) : ProgressStep {
    PARTNER1("validatePartner"),
    PARTNERVALID2("validatePartnerSuccess"),
    SHOWUSER3("showUser")
}

enum class ContactInformationStep(
    override val id: String
) : ProgressStep {
    CONTACTINFO1("contactInfoStep"),
    ADDRESS2("addressStep"),
    SUCCESS3("successStep")
}

enum class ResetStep(
    override val id: String
) : ProgressStep {
    USERINPUT1("validateUser"),
    USERSUCCESS2("validateUserSuccess"),
    PASSWORD3("validateNewPassword"),
    PASSSUCCESS4("resetSuccess")
}

enum class RegistrationStep(
    override val id: String,
    val label: String = "",
    val visible: Boolean = true,
) : ProgressStep {

    MAIL1("validateMailAddress", "Mail-Adresse eingeben"),
    MAILSUCCESS2("sendMailSuccess", "Bestätigungsmail versendet", visible = false),
    USER3("validateUserData", "Benutzerdaten festlegen"),
    SUCCESS4("registrationSuccess", visible = false);

    override fun toString() = label

    companion object {

        val visible = entries.filter { it.visible }
    }
}
